import {
  Box,
  Button,

  Grid,
  IconButton,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React,{useState, } from 'react'
import CustomSearch from "../../Components/Common/CustomSearch";
import { useQuery } from "@apollo/client";

import { GET_TEAMS } from "../../Utils/Queries";
import Loader from "../../Components/Common/Loader";
import DateFormatter from "../../Components/Common/DateFormetter";
import CreateTeam from "../../Components/Team/CreateTeam";
import CreateRole from "../../Components/Team/CreateRoles";
import EditTeam from "../../Components/Team/EditTeam";
import { TbUserSquareRounded } from "react-icons/tb";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import ChevronLeftRoundedIcon from "@mui/icons-material/ChevronLeftRounded";

const Team = () => {

         const [drawerOpen, setDrawerOpen] = React.useState(false);
         const [categoryItem, setCategoryItem] = useState(null);
         const handleDrawerOpen = () => {
           setDrawerOpen(true);
         };

         const handleDrawerClose = () => {
           setDrawerOpen(false);
         };

         const [drawerOpen2, setDrawerOpen2] = React.useState(false);
         const handleDrawerOpen2 = () => {
           setDrawerOpen2(true);
         };

         const handleDrawerClose2 = () => {
           setDrawerOpen2(false);
         };

         const [drawerOpen3, setDrawerOpen3] = React.useState(false);
         const handleDrawerOpen3 = (data) => {
           setDrawerOpen3(true);
           setCategoryItem(data);
         };

         const handleDrawerClose3 = () => {
           setDrawerOpen3(false);
         };

                const  { loading, data, refetch } = useQuery(GET_TEAMS);

                       const [selectedTeam, setSelectedTeam] = useState(null)


                         const [page, setPage] = React.useState(0);
                         const [rowsPerPage, setRowsPerPage] = React.useState(10);
                         const handleChangePageLeft = (event, newPage) => {
                           setPage(page - 1);
                         };
                         const handleChangePageRight = (event, newPage) => {
                           setPage(page + 1);
                         };
                         const handleChangePage = (event, newPage) => {
                           setPage(newPage);
                         };
                       
                         const handleChangeRowsPerPage = (event) => {
                           setRowsPerPage(+event.target.value);
                           setPage(0);
                         };
                         const startRow = page * rowsPerPage + 1;
                         const endRow = Math.min(
                           startRow + rowsPerPage - 1,
                           data?.fetchTeamsWithFilter?.items?.length
                         );
                         const rowsText = `${startRow}-${endRow} of ${data?.fetchTeamsWithFilter?.items?.length}`;
                       
  return (
    <>
      {loading && <Loader />}
      <Box sx={{ bgcolor: "#fff", p: 2 }}>
        <Box sx={{ pt: 2, width: "100%" }}>
          <Grid container spacing={2}>
            <Grid item lg={6} md={6}>
              <CustomSearch placeholder={"Search by Title"} />
            </Grid>
            <Grid item lg={3}>
              <Box>
                <Button
                  onClick={handleDrawerOpen}
                  variant="contained"
                  fullWidth
                  endIcon={<TbUserSquareRounded />}
                >
                  Add User
                </Button>
              </Box>
            </Grid>
            <Grid item lg={3}>
              <Box>
                <Button
                  onClick={handleDrawerOpen2}
                  variant="contained"
                  fullWidth
                  endIcon={<TbUserSquareRounded /> }
                >
                  Create Roles
                </Button>
              </Box>
            </Grid>
          </Grid>

          <Box sx={{ mt: 3 }}>
            <Table>
              <TableHead sx={{ bgcolor: "#F7F6F6" }}>
                <TableRow sx={{ fontSize: "12px" }}>
                  <TableCell>User Name</TableCell>
                  <TableCell>Email Address</TableCell>
                  <TableCell>Role</TableCell>
                  <TableCell>Date Joined</TableCell>
                  <TableCell>Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {!data?.fetchTeamsWithFilter?.items ||
                data?.fetchTeamsWithFilter?.items?.length === 0 ? (
                  <></>
                ) : (
                  <>
                    {data?.fetchTeamsWithFilter?.items.map((item, index) => (
                      <TableRow
                      key={index}
                        sx={{ cursor: "pointer", fontSize: "12px" }}
                        hover
                        onClick={() => {
                          handleDrawerOpen3(item);
                          setSelectedTeam(item)
                        }}
                      >
                        <TableCell>{item?.firstName}</TableCell>
                        <TableCell>{item?.email}</TableCell>
                       <TableCell>{typeof item?.role?.title === "string" ? item?.role?.title : "N/A"}</TableCell>

                        <TableCell>
                          <DateFormatter dateString={`${item?.createdAt}`} />
                        </TableCell>
                        <TableCell>
                          <Typography
                            sx={{
                              bgcolor: " #ECF8F0",
                              px: 1.5,
                              textAlign: "center",
                              fontSize: "12px",
                              fontWeight: 400,
                              py: 1,
                              color: "#3FB763",
                              borderRadius: 2,
                              textTransform: "capitalize",
                            }}
                          >
                            {item?.activityStatus}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    ))}
                  </>
                )}
              </TableBody>
            </Table>
               <Grid container sx={{ bgcolor: "#fff", mt: 3, px: 4, py: 1 }}>
                <Grid
                  item
                  lg={4}
                  md={4}
                  xs={4}
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  <Typography
                    sx={{
                      color: "#424242",
                      fontSize: "12px",
                      fontFamily: "Lato",
                    }}
                  >
                    {rowsText}
                  </Typography>
                </Grid>
                <Grid item lg={8} md={8} xs={8}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      columnGap: 2,
                    }}
                  >
                    <Select
                      size="small"
                      sx={{
                        fontFamily: "Lato",
                        color: "#424242",
                        fontSize: "13px",
                      }}
                      value={rowsPerPage}
                      onChange={handleChangeRowsPerPage}
                      InputProps={{
                        style: {
                          fontFamily: "Lato",
                          fontSize: "13px",
                          // borderRadius: "8px",

                          // Replace with your desired font family
                        },
                      }}
                    >
                      <MenuItem
                        sx={{ fontFamily: "Lato", color: "#424242" }}
                        value={5}
                      >
                        5
                      </MenuItem>
                      <MenuItem
                        sx={{ fontFamily: "Lato", color: "#424242" }}
                        value={10}
                      >
                        10
                      </MenuItem>
                      <MenuItem
                        sx={{ fontFamily: "Lato", color: "#424242" }}
                        value={25}
                      >
                        25
                      </MenuItem>
                      <MenuItem
                        sx={{ fontFamily: "Lato", color: "#424242" }}
                        value={50}
                      >
                        50
                      </MenuItem>
                    </Select>
                    <Box
                      sx={{
                        borderLeft: "1px solid #424242",
                        pl: { md: 4, xs: 2 },
                        ml: { md: 3, xs: 2 },
                      }}
                    >
                      <IconButton 
                        disabled={startRow === 1}
                        onClick={handleChangePageLeft}
                        sx={{
                          width: "30px",
                          height: "30px",
                          border: "1px solid #424242",
                          "&.Mui-disabled": {
                            border: "1px solid #4242421a",
                          },
                        }}
                      >
                        <ChevronLeftRoundedIcon />
                      </IconButton>
                      <IconButton
                        disabled={
                          endRow ===
                          data?.fetchTeamsWithFilter?.items
                            ?.length
                        }
                        onClick={handleChangePageRight}
                        sx={{
                          ml: 4,
                          width: "30px",
                          height: "30px",
                          border: "1px solid #424242",
                          "&.Mui-disabled": {
                            border: "1px solid #4242421a",
                          },
                        }}
                      >
                        <ChevronRightRoundedIcon />
                      </IconButton>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
          </Box>
        </Box>
      </Box>

      <CreateTeam onClose={handleDrawerClose} refetchTeam={refetch} open={drawerOpen} />
      <CreateRole onClose={handleDrawerClose2} open={drawerOpen2} />
      <EditTeam
        onClose={handleDrawerClose3}
        open={drawerOpen3}
        data={selectedTeam}
        refetch={refetch}
      />
    </>
  );
}

export default Team